import { render, staticRenderFns } from "./TiersPayment.vue?vue&type=template&id=6f7ddf26&"
import script from "./TiersPayment.vue?vue&type=script&lang=js&"
export * from "./TiersPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports